import React from "react";
import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { PropertyRegistrationTabs } from "@ippon/shared-components";
import ExpenseSummarySubTab from "./ExpenseSummarySubTab";
import IncomeSummarySubTab from "./IncomeSummarySubTab";
import {
  DEFAULT_EXPENSE_MANAGEMENT_SUBTAB_ID,
  EXPENSE_MANAGEMENT_SUBTABS,
  PROPERTY_DETAIL_TAB_IDS,
  parseTabId,
} from "../tabConfig";
// Phase 1 では融資・積立タブは保留 (⑬〜⑮で対応)
// import LoansSubTab from "./LoansSubTab";

/**
 * 収支タブ (物件詳細 > 収支, top tab index = 5)
 *
 * サブタブ構成 (タスク① 反映後):
 *   支出まとめ → (融資: ⑭) → (積立: ⑮)
 *
 * 設備・修繕は上タブへ昇格したため、本タブからは除外。
 * UI は概要タブと同じ PropertyRegistrationTabs を使用 (カード風タブ)。
 * 外側のグレー背景は pages/properties/Detail の TabPanel 側で提供される。
 */

const TOP_TAB_INDEX = String(PROPERTY_DETAIL_TAB_IDS.MANAGEMENT);

interface ExpenseManagementProps {
  propertyId: string;
  propertyName: string;
}

const ExpenseManagement: React.FC<ExpenseManagementProps> = ({
  propertyId,
  propertyName,
}) => {
  // サブタブ状態を URL ?subtab=N と同期
  const [searchParams, setSearchParams] = useSearchParams();
  const activeIndex = parseTabId(
    searchParams.get("subtab"),
    EXPENSE_MANAGEMENT_SUBTABS,
    DEFAULT_EXPENSE_MANAGEMENT_SUBTAB_ID,
  );

  const handleSubTabChange = (newValue: number) => {
    const next = new URLSearchParams(searchParams);
    next.set("tab", TOP_TAB_INDEX);
    next.set("subtab", String(newValue));
    setSearchParams(next, { replace: true });
  };

  // タブ枠を固定して中身だけをスクロールさせるため、親 TabPanel が
  //   height: calc(100vh - X) + display: flex + overflow: hidden
  // でサイズを決めているので、ここでは flex: 1 で埋めるだけ。
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        minWidth: 0,
      }}
    >
      <PropertyRegistrationTabs
        currentTab={activeIndex}
        tabs={EXPENSE_MANAGEMENT_SUBTABS.slice()}
        onTabChange={handleSubTabChange}
        disableConfirm
        scrollableContent
      >
        {activeIndex === 0 && (
          <ExpenseSummarySubTab
            propertyId={propertyId}
            propertyName={propertyName}
          />
        )}
        {activeIndex === 1 && (
          <IncomeSummarySubTab
            propertyId={propertyId}
            propertyName={propertyName}
          />
        )}
      </PropertyRegistrationTabs>
    </Box>
  );
};

export default ExpenseManagement;
